import { localget, localremove, localset, sessionremove } from 'Utils/storage';
import { getDeviceInfo } from 'CommonUtils/plus';
import { ifStrBlank } from 'Utils/string';
import { parseQueryString } from 'Utils/tools';
import aes from 'Utils/aes';
import consts from 'Utils/consts';

import { Toast } from 'vant';
import { GAT_CONFIG } from 'Config/index';
import router from 'Plugins/router';

/**
 * 第三方授权注册函数
 * async function f(queryParams) {
 *    queryParams.channelParam = 'AES加密的json对象'
 * }
 * 注册函数里面有判断逻辑到底要不要执行 不把 channelParam 设置给 queryParams 就不会执行
 * 注意：需要把 channelParam 设置给 queryParams
 * channelParam AES加密的json对象
 */
const RegisterFuncs = [];

export default {
  async created() {
    // 注册第三方注册行数
    await this.initThirdRegisterFunc();
    // 第三方授权登录，在具体的组件内部调用
    // await this.auth()
  },
  methods: {
    // 注册第三方授权注册函数
    async initThirdRegisterFunc() {
      RegisterFuncs.push(this.gatRegister);
    },
    // 第三方授权登录
    async auth() {
      const loading = Toast({duration: 0, message: '加载中...', forbidClick: true});
      try {
        await this.doAuth();
      } catch (e) {
        console.error('初始化登录出错:', e);
        Toast.fail({duration: 10000, message: '初始化登录出错:' + JSON.stringify(e)});
      } finally {
        loading.clear();
      }
    },
    // 第三方授权登录
    async doAuth() {

      // 获取url参数
      const queryParams = parseQueryString(window.location.href);

      // 调用第三方授权注册函数
      for (let i = 0; i < RegisterFuncs.length; i++) {
        await RegisterFuncs[i].call(this, queryParams);
      }

      // 根据渠道参数进行登录
      if (queryParams.channelParam) {
        const aesKey = queryParams.aesKey || aes.defaultKey;
        const channelParam = JSON.parse(aes.decrypt(decodeURIComponent(queryParams.channelParam), aesKey));

        // 检验参数
        if (ifStrBlank(channelParam.loginName) || ifStrBlank(channelParam.accessChannel)) {
          this.$toast('初始化用户信息失败，请您退出重试');
          return;
        }

        // 保存渠道参数
        localStorage.setItem(consts.fromSource, JSON.stringify(channelParam));
        this.channelParam = channelParam;

        // 针对已登录的用户，并且开启了登录检测，不再登录
        if (queryParams.enableLoginCheck && (channelParam.isLogin || queryParams.isLogin)) {
          return;
        }
        // 实际登录逻辑
        await this.doLogin(queryParams, channelParam);
      }
    },
    // 登录逻辑
    async doLogin(queryParams, channel) {
      // 登录参数
      const params = {
        account: '', //不知
        compId: channel.companyId,
        corpId: channel.corpId,
        loginName: channel.loginName, //手机号
        deviceShortname: getDeviceInfo().deviceShortname, //设置型号
        deviceId: getDeviceInfo().deviceId, //设备标识
        autologinType: channel.loginType || 2, //(integer, optional): 登陆方式,1-自动登录2-手动登录
        loginWay: 4,// 1-密码登录 2-验证码 3-注册4-第三方跳转
        password: channel.password,// 密码
        openId: '',
        doNotRedirect: queryParams.doNotRedirect || false,
      };
      // 清除登录状态
      await this.clearLoginState();
      // 登录接口
      await this.$store.dispatch('login', params);
      // 保存渠道参数，不论实际登录成功与否
      localset(consts.thirdChannelParam, channel);
      // 登录成功后，保存渠道参数
      let isLogin = await this.checkLoginState();
      if (isLogin) {
        if (queryParams.afterLogin && typeof queryParams.afterLogin === 'function') {
          queryParams.afterLogin();
        }
      }
    },
    // 检测登录状态
    async checkLoginState() {
      const token = localget('access_token');
      return token && token.length >= 32;
    },
    // 清除登录状态
    async clearLoginState() {
      // sessionremove('VUEX_STATE')
      // localremove('VUEX_STATE')
      localremove('userInfo');
      localremove('access_token');
    },
    // 关爱通跳转授权注册
    async gatRegister(queryParams) {

      // 检验是否关爱通授权码跳转过来的
      if (!queryParams || !queryParams.auth_code) {
        localset('notlogGAT', '');
        return;
      }

      // 获取授权码
      queryParams.aesKey = aes.gatKey;

      // 调关爱通授权注册接口
      const params = {
        authCode: queryParams.auth_code,
        corpId: GAT_CONFIG.gatCorpId,
      };

      // 调后端关爱通授权注册接口
      localset('notlogGAT', '关爱通');
      let result;
      try {
        result = await this.$api['user/userRegister4Gat'](params);
      } catch (ignore) {// 接口异常无需处理程序会自动处理
        console.error('关爱通授权注册失败: 100', ignore);
        return;
      } finally {
        // 不管成功失败都要设置渠道参数，若登录成功，会覆盖此参数
        // 无论如何都要设置渠道参数，以确定是关爱通授权码跳转过来的
        localset(consts.thirdChannelParam, {accessChannel: 'gat'});
      }

      const {data} = result;
      if (data.code !== '200') {
        console.error('关爱通授权注册失败:', data);
        Toast.fail({duration: 5000, message: `授权失败：${data.code}`});
        return;
      }

      // 渠道参数
      if (data.channelParam) {
        queryParams.channelParam = data.channelParam;
        queryParams.enableLoginCheck = false;// 关闭登录检测
        queryParams.doNotRedirect = true;// 不跳转
        queryParams.afterLogin = function () {
          router.replace({path: '/home'});
        }
      } else {
        console.error('关爱通授权注册失败:', data);
        Toast.fail({duration: 5000, message: '授权失败：101'});
      }
    },
  }
};
